import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Search, User, MoreVertical } from "lucide-react";
import api from "../utils/api";
const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [loadingStates, setLoadingStates] = useState({});
  const [loadingStatesReject, setLoadingStatesReject] = useState({});
  const [loadingStatesReset, setLoadingStatesReset] = useState({});

  const handleResetPassword = async (mobileNo) => {
    setLoadingStatesReset((prev) => ({ ...prev, [mobileNo]: true }));

    try {
      const response = await api.put("/api/user.php", {
        api: "resetpassword",
        mobileno: mobileNo,
      });

      if (response.status === 200) {
        Swal.fire({
          title: "Password Reset!",
          text: "User password has been reset to 'Vetri'",
          icon: "success",
        });
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to reset user password",
        icon: "error",
      });
    } finally {
      setLoadingStatesReset((prev) => ({ ...prev, [mobileNo]: false }));
    }
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await api.get("/api/user.php");
      console.log("Response:", response.data);
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUsers();
  }, []);
  const handleApprove = async (userId, approval) => {
    if (approval === 1)
      setLoadingStates((prev) => ({ ...prev, [userId]: true }));
    else setLoadingStatesReject((prev) => ({ ...prev, [userId]: true }));

    try {
      const response = await api.put("/api/user.php", {
        id: userId,
        api: "approve",
        approved: approval,
      });
      if (response.status === 200) {
        Swal.fire({
          title: approval === 1 ? "Approved!" : "Rejected!",
          text: response.data.message,
          icon: "success",
        });
        // Fetch updated user list instead of page reload
        await fetchUsers();
      }
    } catch (error) {
      console.error("Error approving user:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to update user status",
        icon: "error",
      });
    } finally {
      setLoadingStates((prev) => ({ ...prev, [userId]: false }));
      setLoadingStatesReject((prev) => ({ ...prev, [userId]: false }));
    }
  };

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-900">
            User Management
          </h2>
          <div className="relative w-full max-w-xs">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search users..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors duration-200"
            />
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
              <Search className="w-5 h-5" />
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          {loading ? (
            <div className="flex justify-center py-8">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user) => (
                  <div
                    key={user.id}
                    className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-md"
                  >
                    <div className="p-5">
                      <div className="flex items-start justify-between">
                        <div className="flex items-center">
                          <div className="flex-shrink-0">
                            <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600">
                              <User className="w-6 h-6" />
                            </div>
                          </div>
                          <div className="ml-4">
                            <h3 className="text-lg font-medium text-gray-900">
                              {user.name}
                            </h3>
                            <p className="text-sm text-gray-500">
                              {user.mobileno}
                            </p>
                            <span
                              className={`inline-block mt-1 text-xs font-medium px-2.5 py-0.5 rounded-full ${
                                user.Approved === 0
                                  ? "bg-yellow-100 text-yellow-800"
                                  : "bg-green-100 text-green-800"
                              }`}
                            >
                              {user.Approved === 0 ? "Pending" : "Approved"}
                            </span>
                          </div>
                        </div>
                        <div className="relative">
                          <button
                            onClick={() =>
                              setActiveDropdown(
                                activeDropdown === user.id ? null : user.id
                              )
                            }
                            className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
                          >
                            <MoreVertical className="w-5 h-5 text-gray-500" />
                          </button>

                          {activeDropdown === user.id && (
                            <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200">
                              {user.Approved === 0 && (
                                <button
                                  onClick={() => {
                                    handleApprove(user.id, 1);
                                    setActiveDropdown(null);
                                  }}
                                  className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4 mr-2 text-green-500"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M5 13l4 4L19 7"
                                    />
                                  </svg>
                                  Approve
                                </button>
                              )}
                              <button
                                onClick={() => {
                                  handleApprove(user.id, 0);
                                  setActiveDropdown(null);
                                }}
                                className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4 mr-2 text-red-500"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                  />
                                </svg>
                                Reject
                              </button>
                              <button
                                onClick={() => {
                                  handleResetPassword(user.mobileno);
                                  setActiveDropdown(null);
                                }}
                                className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4 mr-2 text-blue-500"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                  />
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                  />
                                </svg>
                                Reset Password
                              </button>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="mt-4 flex flex-wrap gap-2">
                        {user.Approved === 0 && (
                          <button
                            onClick={() => handleApprove(user.id, 1)}
                            disabled={loadingStates[user.id]}
                            className="px-3 py-1 text-sm font-medium text-white bg-green-500 rounded-md hover:bg-green-600 disabled:opacity-50 flex items-center gap-2 transition-colors duration-200"
                          >
                            {loadingStates[user.id] ? (
                              <>
                                <svg
                                  className="animate-spin h-4 w-4 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                                Processing...
                              </>
                            ) : (
                              "Approve"
                            )}
                          </button>
                        )}
                        <button
                          onClick={() => handleApprove(user.id, 0)}
                          disabled={loadingStatesReject[user.id]}
                          className="px-3 py-1 text-sm font-medium text-white bg-red-500 rounded-md hover:bg-red-600 disabled:opacity-50 flex items-center gap-2 transition-colors duration-200"
                        >
                          {loadingStatesReject[user.id] ? (
                            <>
                              <svg
                                className="animate-spin h-4 w-4 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              Processing...
                            </>
                          ) : (
                            "Reject"
                          )}
                        </button>
                        <button
                          onClick={() => handleResetPassword(user.mobileno)}
                          disabled={loadingStatesReset[user.mobileno]}
                          className="px-3 py-1 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 disabled:opacity-50 flex items-center gap-2 transition-colors duration-200"
                        >
                          {loadingStatesReset[user.mobileno] ? (
                            <>
                              <svg
                                className="animate-spin h-4 w-4 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              Processing...
                            </>
                          ) : (
                            "Reset Password"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-span-full text-center py-8 text-gray-500">
                  No users found matching your search criteria.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;
